import { createSlice } from "@reduxjs/toolkit";

const blogSlice = createSlice({
  name: "blog",
  initialState: {
    selectedBlog: JSON.parse(localStorage.getItem("selectedBlog")) || null,
  },
  reducers: {
    // ✅ Set selected blog and store in localStorage
    setSelectedBlog: (state, action) => {
      state.selectedBlog = action.payload;
      localStorage.setItem("selectedBlog", JSON.stringify(action.payload));
    },

    // ❌ Clear selected blog
    clearSelectedBlog: (state) => {
      state.selectedBlog = null;
      localStorage.removeItem("selectedBlog");
    },
  },
});

export const { setSelectedBlog, clearSelectedBlog } = blogSlice.actions;
export default blogSlice.reducer;
